module.exports = __webpack_public_path__ + "img/stock2.49e997f1.png";